import Page from "../pages/Contact";
import { pageMeta } from "../lib/meta";
import { OG_IMAGE } from "../config/heroArt";
export const meta = () => pageMeta({ title: "Contact | Gazar", description: "Want to work together, book a session, or just say hello? Here's how to reach me.", path: "/contact", image: OG_IMAGE.contact });
export default function Contact() { return <Page />; }
